import request from './httpService';

const PROCUREMENT_API_ENDPOINT = '/procurement';

const createPurchaseOrder = (data) => {
  return request({
    method: 'POST',
    url: `${PROCUREMENT_API_ENDPOINT}/purchase-orders`,
    data
  });
};

const listPurchaseOrders = (params = {}, signal) => {
  return request({
    method: 'GET',
    url: `${PROCUREMENT_API_ENDPOINT}/purchase-orders`,
    params,
    signal
  });
};

const listNewOrders = (params = {}, signal) => {
  return request({
    method: 'GET',
    url: `${PROCUREMENT_API_ENDPOINT}/new-orders`,
    params,
    signal
  });
};

const updateQueuedOrder = (pendingOrderId, data) => {
  return request({
    method: 'PUT',
    url: `${PROCUREMENT_API_ENDPOINT}/new-orders/${pendingOrderId}`,
    data
  });
};

const placeQueuedOrder = (pendingOrderId, data) => {
  return request({
    method: 'POST',
    url: `${PROCUREMENT_API_ENDPOINT}/new-orders/${pendingOrderId}/place-order`,
    data
  });
};

const receivePurchaseOrder = (purchaseOrderId, data) => {
  return request({
    method: 'POST',
    url: `${PROCUREMENT_API_ENDPOINT}/purchase-orders/${purchaseOrderId}/receive`,
    data
  });
};

const cancelPurchaseOrder = (purchaseOrderId, data = {}) => {
  return request({
    method: 'POST',
    url: `${PROCUREMENT_API_ENDPOINT}/purchase-orders/${purchaseOrderId}/cancel`,
    data
  });
};

const createDirectReceipt = (data) => {
  return request({
    method: 'POST',
    url: `${PROCUREMENT_API_ENDPOINT}/receipts`,
    data
  });
};

const listReceipts = (params = {}, signal) => {
  return request({
    method: 'GET',
    url: `${PROCUREMENT_API_ENDPOINT}/receipts`,
    params,
    signal
  });
};

export const ProcurementService = {
  createPurchaseOrder,
  listPurchaseOrders,
  listNewOrders,
  updateQueuedOrder,
  placeQueuedOrder,
  receivePurchaseOrder,
  cancelPurchaseOrder,
  createDirectReceipt,
  listReceipts
};
